import {ProductInterface} from "../interfaces/catalog/ProductInterface";

/**
 * Сортирует продукты так, чтобы товары в наличии отображались первыми
 * @param products - массив продуктов для сортировки
 * @returns отсортированный массив продуктов
 */
export const sortProductsByStock = (products: ProductInterface[]): ProductInterface[] => {
    return [...products].sort((a, b) => {
        const aInStock = a.has_stock;
        const bInStock = b.has_stock;

        if (aInStock && !bInStock) return -1;
        if (!aInStock && bInStock) return 1;
        return 0;
    });
};